import { DetailsCaseState } from './types';
import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import * as caseActions from './actions';
import { CaseViewResponse } from './model';

export type CaseAction = ActionType<typeof caseActions>;

const initialState: DetailsCaseState = {
  caseCode: '',
  incidentAndDamage: {
    damageLossDate: '',
    damageLossTime: '',
    damageLossCategory: '',
    damageLossCause: '',
    damageCauseDescription: '',
    creator: '',
    insurerHandlingPerson: '',
    reportedToPolice: false,
    investigationOfficerName: '',
    policeStation: '',
    interventionFireBrigade: false,
    fireBrigadeStation: '',
    repairedByCustomer: false,
    vatClient: false,
    vatPercentage: '',
    crimeReferenceNumber: '',
    policeReportDate: '',
    instructionText: '',
    remarks: '',
    // Schade - damage
    buildingDamageLossDamageDescription: '',
    buildingDamageLossEstimatedDamageAmount: 0,
    contentDamageLossDamageDescription: '',
    contentDamageLossEstimatedDamageAmount: 0,
    glassDamageLossDamageDescription: '',
    glassDamageLossEstimatedDamageAmount: 0,
    basementDamageLossDamageDescription: '',
    basementDamageLossEstimatedDamageAmount: 0,
    allRiskObjectDamageLossDamageDescription: '',
    allRiskObjectDamageLossEstimatedDamageAmount: 0,
  },
  policyHolderRepresentative: {
    id: 0,
    firstName: '',
    lastName: '',
    companyName: '',
    occupancy: '',
    companyNumber: '',
    clientType: '',
    street: '',
    buildingNumber: '',
    busNumber: '',
    zipCode: '',
    city: '',
    country: '',
    accountNumber: '',
    iban: '',
    bic: '',
    telephone: '',
    telephoneWork: '',
    mobile: '',
    fax: '',
    email: '',
    language: '',
    sequence: 0,
  },
  policyHolderCounterExpert: {
    id: 0,
    firstName: '',
    lastName: '',
    companyName: '',
    occupancy: '',
    companyNumber: '',
    clientType: '',
    street: '',
    buildingNumber: '',
    busNumber: '',
    zipCode: '',
    city: '',
    country: '',
    accountNumber: '',
    iban: '',
    bic: '',
    telephone: '',
    telephoneWork: '',
    mobile: '',
    fax: '',
    email: '',
    language: '',
    sequence: 0,
  },
  responsableParty: {
    id: 0,
    firstName: '',
    lastName: '',
    companyName: '',
    occupancy: '',
    companyNumber: '',
    clientType: '',
    street: '',
    buildingNumber: '',
    busNumber: '',
    zipCode: '',
    city: '',
    country: '',
    accountNumber: '',
    iban: '',
    bic: '',
    telephone: '',
    telephoneWork: '',
    mobile: '',
    fax: '',
    email: '',
    language: '',
    sequence: 0,
  },
  responsablePartyExpert: {
    id: 0,
    firstName: '',
    lastName: '',
    companyName: '',
    occupancy: '',
    companyNumber: '',
    clientType: '',
    street: '',
    buildingNumber: '',
    busNumber: '',
    zipCode: '',
    city: '',
    country: '',
    accountNumber: '',
    iban: '',
    bic: '',
    telephone: '',
    telephoneWork: '',
    mobile: '',
    fax: '',
    email: '',
    language: '',
    sequence: 0,
  },
  witnesses: [],
  injuredPersons: [],
  personsHadDamage: [],
  case: {
    instructionId: 0,
    taskType: '',
    visitDate: '', // Use an ISO string or null
    caseCode: '',
    expertName: '',
    damageCauseIcon: '',
    insuredPersonName: '',
    causeOfDamage: '',
    damageCauseDescription: '',
    insurer: '',
    sizeOfDamage: '',
    againstParty: '',
    claimNotificationId: 0,
    taskId: 0,
    refuseReasonTC: '',
    refuseReasonText: '',
    archived: false,
    assignedUserId: 0,
    offline: false,
    damageIcon: '',
    approved: false,
    hasHonoraryNote: false,
    isRead: false,
    policySubTypeTC: '',
    createdOn: '', // Use an ISO string or null
    riskAddressId: 0,
    riskCity: '',
    riskStreet: '',
    riskBuildingNumber: '',
    riskBoxNumber: '',
    riskZipCode: '',
    addressId: null,
    telephone: '',
    mobile: '',
    policyHolderCity: '',
    policyHolderStreet: '',
    policyHolderBuildingNumber: '',
    policyHolderBoxNumber: '',
    policyHolderZipCode: '',
    policyHolderLanguageTC: '',
    blocked: true,
    agendaReference: '',
    responsibleInsurerCaseNumber: '',
    responsiblePartyLicensePlate: '',
    responsiblePartyPolicyType: '',
    responsiblePartyInsurerName: '',
    allApproved: false,
    anythingForApproval: false,
    allHnApproved: false,
    anyHnForApproval: false,
    parentPartyDibCode: '',
    parentPartyName: '',
    inProgress: false,
    instructionText: '',
  },
};

const reducer: Reducer<DetailsCaseState, CaseAction> = (state = initialState, action: CaseAction): DetailsCaseState => {
  switch (action.type) {
    case getType(caseActions.fetchCaseView): {
      return { 
        ...state, 
      };
    }
    case getType(caseActions.fetchCaseViewSuccess): {
      const payload: CaseViewResponse = action.payload as CaseViewResponse;
      return {
        ...state,
        incidentAndDamage: { ...payload.incidentAndDamage },
        policyHolderRepresentative: { ...payload.policyHolderRepresentative },
        policyHolderCounterExpert: { ...payload.policyHolderCounterExpert },
        responsableParty: { ...payload.responsableParty },
        responsablePartyExpert: { ...payload.responsablePartyExpert },
        witnesses: payload.witnesses.slice(),
        injuredPersons: payload.injuredPersons.slice(),
        personsHadDamage: payload.personsHadDamage.slice(),
        case: { ...payload.case },
      };
    }
    case getType(caseActions.resetDetailsCaseState): {
      return initialState;
    }
    case getType(caseActions.fetchCaseViewError):
      return {...state};
    default:
      return state;
  }
};

export { reducer as detailsCaseReducer, initialState as detailsCaseInitialState };
